/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useState } from 'react'
import { Hidden, Visible } from 'react-grid-system';
import { Icon, Paper, Separator, Size } from '@vaisala/rockhopper-components';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';

import ParameterCard, { CardType } from './ParameterCard';
import { OptionsConfig } from './OptionsModal';
import ValidityIndicator from './ValidityIndicator';
import { CalculatorResult, ParameterModifier, ParameterName, ParameterValueElement } from '../../modules/calculator/calculatorTypes';
import './ParameterControls.scss';

const paramConfig = require('../../modules/calculator/parameterConfig.json');

export interface ParameterConsumerProps {
  currentResult?: CalculatorResult;
  advancedMode: boolean;
  onParameterChange: (parameterName: ParameterName, element: ParameterValueElement, value: ParameterModifier) => void;
  selectedRowIndex: number;
  onSelectRow: (ind: number, parameterName: ParameterName) => void;
  onSelectUnit: (parameterName: ParameterName, unitIndex: number) => void;
  onHelpOpen: VoidFunction;
  onOptionsOpen: (title: string, config: OptionsConfig) => void;
  elevationMode: boolean;
  onToggleElevation: (forceElevation?: boolean) => void;
}

export interface ParameterControlsProps extends ParameterConsumerProps {}

const ParameterControls = (props: ParameterControlsProps) => {
  const { onHelpOpen } = props;
  const [editCondition, setEditCondition] = useState<'temperature' | 'pressure' | 'elevation' | null>(null);

  const renderCard = (
    i: number,
    type: CardType,
    selectable: boolean,
    showResults: boolean,
    showControls: boolean,
    headerHelp: string,
    headerArrow: boolean,
    headers: string[]
  ) => (
    <ParameterCard
      config={paramConfig.cards[i]}
      cardType={type}
      isSelectable={selectable}
      showResults={showResults}
      showControls={showControls}
      headers={headers}
      headerHelp={headerHelp}
      headerArrow={headerArrow}
      editCondition={editCondition}
      setEditCondition={setEditCondition}
      {...props}
    />
  );

  return (
    <>
      <Visible xs sm>
        <Paper className="parameter-paper">
          {renderCard(0, 'ambient', false, false, true, 'tooltip.ambientConditions', false, ['card.ambientConditions'])}
          <Separator />
          {renderCard(1, 'selector', false, false, true, `tooltip.${paramConfig.cards[1].rows[props.selectedRowIndex].labelKey}`, false, [
            'card.from',
            '',
            '',
          ])}
        </Paper>
        <div className="arrow-icon-wrap">
          <Icon size={Size.L} name={VaiIcon.ArrowDown} />
        </div>
        <Paper className="parameter-paper">{renderCard(1, 'humidity', false, true, false, '', false, ['card.to'])}</Paper>
        <ValidityIndicator state={props.currentResult?.validityStates?.[0]} variant="mobile" onShowHelp={onHelpOpen} />
      </Visible>

      <Hidden xs sm>
        <Paper className="parameter-paper">
          {renderCard(0, 'ambient', false, false, true, 'tooltip.ambientConditions', false, ['card.ambientConditions'])}
          <Separator />
          {renderCard(1, 'humidity', true, true, true, '', true, ['card.select', 'card.from', 'card.to'])}
          <ValidityIndicator state={props.currentResult?.validityStates?.[0]} variant="desktop" onShowHelp={onHelpOpen} />
        </Paper>
      </Hidden>
    </>
  );
};

export default ParameterControls;
